module.exports = __webpack_public_path__ + "static/img/ibemec.318c29f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ibemec.png
// module id = 232
// module chunks = 6